(() => {
    /**
     Version: 3.3
     Title: Journey CMP with Shopify Customer Privacy API and Cookie Storage for Analytics & Marketing
     Author: Journey Agency Norway AS
     Author URI: https://journeyagency.com/
     */

    "use strict";

    const COOKIE_BANNER = document.getElementById("cookie-consent-banner");
    const COOKIE_BANNER_CONSENT = document.getElementById("cookie-consent-banner-consent");
    const COOKIE_BANNER_DECLINE = document.getElementById("cookie-consent-banner-decline");

    // Helper function to set a cookie
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Helper function to get a cookie
    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Check choice from cookies
    if (getCookie("cookie-consent-banner") === "accepted" || getCookie("cookie-consent-banner") === "declined") {
        hideCookieBanner();
    }

    COOKIE_BANNER_CONSENT.addEventListener("click", function (event) {
        event.preventDefault();
        hideCookieBanner();

        setCookie("cookie-consent-banner", "accepted", 365); // Setting cookie for a year

        // Set customer's consent status to "accepted" for both analytics and marketing using Shopify's Privacy API
        window.Shopify.customerPrivacy.setTrackingConsent(
  {
    "analytics":    true,
    "marketing":    true,
    "preferences":  true,
  },
  () => console.log("Consent captured")
);
    });

    COOKIE_BANNER_DECLINE.addEventListener("click", function (event) {
        event.preventDefault();
        hideCookieBanner();

        setCookie("cookie-consent-banner", "declined", 365); // Setting cookie for a year

        // Set customer's consent status to "declined" for both analytics and marketing using Shopify's Privacy API
        window.Shopify.customerPrivacy.setTrackingConsent(
  {
    "analytics":    false,
    "marketing":    false,
    "preferences":  true,
  },
  () => console.log("Consent captured")
);
    });

    function hideCookieBanner() {
        COOKIE_BANNER.style.display = "none";
    }

})();
